import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import '../scss/ourJourney.scss';
import Header from './components/header';
import { Global } from './common/global';
import $ from 'jquery';
gsap.registerPlugin(ScrollTrigger);

let currentScroll = 0;
let scrollPercentage = 0;

const video = document.getElementById('timelineVideo');

// Load header and footer
video.addEventListener('loadedmetadata', function () {
  video.currentTime = 0.1; // Small offset to avoid frozen first frame
  video.play().then(() => video.pause());
});
let videoToLoad = [
  {
    key: 'video_1',
    url: `ui/video/timelinev2.mp4`,
    status: 'not_loaded',
  },
];
let videoArr = [];
let videoLoadPercentage = 0;

window.onload = function () {
  preloadVideo(
    `${videoToLoad[0]['url']}?raw=true`,
    videoToLoad[0]['key'],
    1
  ).then(
    function () {
      videoToLoad['status'] = 'loaded';
      video.src = videoArr[0].data;
      document.querySelector('.celebrartion').classList.add('active');
      gsap.to('#loaderMaskRect', {
        attr: { width: Math.min(window.innerWidth, window.innerHeight * 2) },
        duration: 1, // seconds
        ease: 'power2.out',
        onComplete: function () {
          setTimeout(() => {
            document.querySelector('.page_loader').classList.add('loaded');
            document.querySelector('#timelineVideo').play();
            document.querySelector('.timelineContainer').style.overflowY =
              'scroll';
          }, 250);
        }.bind(this),
      });
    }.bind(this)
  );

  fetch('./partials/header.html')
    .then((res) => res.text())
    .then((html) => {
      document.getElementById('header').innerHTML = html;
    });
  fetch('./partials/footer.html')
    .then((res) => res.text())
    .then((html) => {
      document.getElementById('footer').innerHTML = html;
    });
  setTimeout(() => {
    new Header();
    document.querySelector('#header header').classList.add('active');
    document.querySelector('#footer footer').classList.add('active');
  }, 1500);
};
setTimeout(() => {
  document.querySelector('.scroll_hint').classList.add('active');
}, 1000);
document.querySelector('.scroll_hint').addEventListener('click', function () {
  document.querySelector('.timelineContainer').scrollBy({
    top: 1500,
    behavior: 'smooth',
  });
  document.querySelector('.scroll_hint').classList.remove('active');
  setTimeout(() => {
    document.querySelector('.scroll_hint').style.display = 'none';
  }, 500);
});
gsap.to('.scroll_hint .icon *', {
  y: `-=7`,
  duration: 0.75,
  ease: 'expo.out',
  yoyo: true,
  repeat: -1,
  // repeatDelay:1,
});
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let utm_source = urlParams.get('utm_source');
let utm_medium = urlParams.get('utm_medium');
let utm_campaign = urlParams.get('utm_campaign');
let utm_term = urlParams.get('utm_term');
Global.U_ID = localStorage.getItem('U_ID');

if (
  (Global.U_ID == null || Global.U_ID == '' || Global.U_ID == 0,
  Global.U_ID == undefined)
) {
  $.ajax({
    type: 'POST',
    url: 'https://newsfeedsmartapp.com/Jafza/api/createUser.php',
    data: {
      page: 'home_click',
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
    },
    dataType: 'json',
    success: function (resultData) {
      var res = resultData;
      Global.U_ID = res.UID;
      localStorage.setItem('U_ID', Global.U_ID);
    },
  });
} else {
  $.ajax({
    type: 'POST',
    url: 'https://newsfeedsmartapp.com/Jafza/api/valueUpdator.php',
    data: {
      saveType: 'our_journey_click',
      uniqID: Global.U_ID,
    },
    dataType: 'json',
    success: function (resultData) {
      var res = resultData;
    },
  });
}
// Create a master timeline
const masterTimeline = gsap.timeline({ paused: true });

// Timeline animation helper
function scrollAnim(trigger, y1, y2, timeOffset) {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: trigger,
      scroller: '.timelineContainer',
      start: 'bottom bottom',
      end: 'bottom bottom',
      toggleActions: 'play none none reverse',
      markers: false,
      once: false,
      onEnter: () => console.log(`${trigger} animation started.`),
      onLeave: () => console.log(`${trigger} animation complete.`),
    },
  });

  if (isMobile()) {
    timeline
      // .to(y2, { top: "52%", duration: 0.8, ease: "power2.out" })
      .to(y1, { top: '-100%', duration: 0.8, ease: 'power2.inOut' }, '+=0.1')
      .to(y2, { top: '25%', duration: 0.4, ease: 'power2.inOut' }, '-=0.4');
  } else {
    timeline
      // .to(y2, { top: "52%", duration: 0.8, ease: "power2.out" })
      .to(y1, { top: '-100%', duration: 0.8, ease: 'power2.inOut' }, '+=0.1')
      .to(y2, { top: '50%', duration: 0.4, ease: 'power2.inOut' }, '-=0.4');
  }
  masterTimeline.add(timeline, timeOffset);

  if (masterTimeline.paused()) {
    masterTimeline.play();
  }
}

// Setup scroll animations for all segments
scrollAnim('.article2', '.year1', '.year2', 0);
scrollAnim('.article3', '.year2', '.year3', '+=1');
scrollAnim('.article4', '.year3', '.year4', '+=1');
scrollAnim('.article5', '.year4', '.year5', '+=1');
scrollAnim('.article28', '.year5', '.year6', '+=1');
scrollAnim('.article6', '.year6', '.year7', '+=1');
scrollAnim('.article7', '.year7', '.year8', '+=1');
scrollAnim('.article10', '.year8', '.year9', '+=1');
scrollAnim('.article11', '.year9', '.year10', '+=1');
scrollAnim('.article12', '.year10', '.year11', '+=1');
scrollAnim('.article13', '.year11', '.year12', '+=1');
scrollAnim('.article14', '.year12', '.year13', '+=1');
scrollAnim('.article15', '.year13', '.year14', '+=1');
scrollAnim('.article16', '.year14', '.year15', '+=1');
scrollAnim('.article17', '.year15', '.year16', '+=1');
scrollAnim('.article19', '.year16', '.year17', '+=1');
scrollAnim('.article20', '.year17', '.year18', '+=1');
scrollAnim('.article21', '.year18', '.year19', '+=1');
scrollAnim('.article22', '.year19', '.year20', '+=1');
scrollAnim('.article23', '.year20', '.year21', '+=1');
// scrollAnim('.header1', '.year21', '.year22', '+=1');
scrollAnim('.article24', '.year21', '.year22', '+=1');
scrollAnim('.article26', '.year22', '.year23', '+=1');
scrollAnim('.article27', '.year23', '.year24', '+=1');

// Make ScrollTrigger aware of custom scroll container
ScrollTrigger.scrollerProxy('.timelineContainer', {
  scrollTop(value) {
    const container = document.querySelector('.timelineContainer');
    if (arguments.length) {
      container.scrollTop = value;
    }
    return container.scrollTop;
  },
  getBoundingClientRect() {
    return {
      top: 0,
      left: 0,
      width: window.innerWidth,
      height: window.innerHeight,
    };
  },
  pinType: document.querySelector('.timelineContainer').style.transform
    ? 'transform'
    : 'fixed',
});

// Update on scroll
const timelineContainer = document.querySelector('.timelineContainer');
const maxScroll =
  timelineContainer.scrollHeight - timelineContainer.clientHeight;

let lastUpdate = 0;
const updateInterval = 1;

// ~60fps
timelineContainer.addEventListener('scroll', () => {
  if (document.querySelector('.scroll_hint').classList.contains('active')) {
    document.querySelector('.scroll_hint').classList.remove('active');
  }
});
function isMobile() {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}
// Parallax effect for .textContainer (after DOM load)
window.addEventListener('load', () => {
  setTimeout(() => {
    let k = 200;
    let l = 200;
    if (isMobile()) {
      k = 50;
      l = 75;
    }
    gsap.utils.toArray('.textContainer').forEach((el) => {
      // Skip element if it has the class 'no-parallax'
      if (el.classList.contains('no-parallax')) return;

      gsap.to(el, {
        y: k,
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          scroller: '.timelineContainer',
          // markers: true // Uncomment for debugging
        },
      });
    });

    gsap.utils.toArray('.imageSecond').forEach((el) => {
      gsap.to(el, {
        y: l,
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          scroller: '.timelineContainer',
          // markers: true // Uncomment for debugging
        },
      });
    });

    let ticking = false;

    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray('.header').forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          trigger: el,
          scroller: '.timelineContainer',
          start: 'top 80%',
          toggleActions: 'play none none reverse',
        },
        opacity: 0,
        scale: 0.8,
        duration: 0.8,
        ease: 'power2.out',
      });
    });
    gsap.from('.header3', {
      scrollTrigger: {
        trigger: '.article5',
        scroller: '.timelineContainer',
        start: 'top 80%',
        toggleActions: 'play none none reverse',
      },
      opacity: 0,
      scale: 0.8,
      duration: 0.8,
      ease: 'power2.out',
    });
    gsap.utils.toArray('.imageContainer').forEach((el) => {
      gsap.set(el, {
        opacity: 0,
        scale: 0.9,
        filter: 'blur(10px)',
      });

      // Animate on scroll
      gsap.to(el, {
        scrollTrigger: {
          trigger: el,
          scroller: '.timelineContainer',
          start: 'top 80%',
          end: 'bottom top',
          toggleActions: 'play none none reverse',
          markers: false,
        },
        opacity: 1,
        scale: 1,
        filter: 'blur(0px)',
        duration: 1,
        ease: 'power2.out',
      });
    });
    gsap.to('.borderRing', {
      rotation: 360,
      transformOrigin: '50% 50%',
      repeat: -1,
      ease: 'linear',
      duration: 3,
    });
    gsap.utils.toArray('.Title').forEach((el) => {
      // Initial state: flipped backward and hidden
      gsap.set(el, {
        opacity: 0,
        rotationX: -90,
        transformPerspective: 800,
        transformOrigin: 'center top',
      });

      // Animate on scroll
      gsap.to(el, {
        scrollTrigger: {
          trigger: el,
          scroller: '.timelineContainer',
          start: 'top 80%',
          end: 'bottom top',
          toggleActions: 'play none none reverse', // Play on scroll down, reverse on scroll up
          markers: false,
        },
        opacity: 1,
        rotationX: 0,
        duration: 1,
        ease: 'bounce.out',
      });
    });
    // 1. Split each letter into <span class="char">
    // Split text into spans (one per character)
    // Split text into spans for characters, but skip wrapping spaces
    document.querySelectorAll('.textContainer .light-text').forEach((el) => {
      const chars = el.textContent.split('');
      el.innerHTML = chars
        .map((char) =>
          char === ' ' ? ' ' : `<span class="char">${char}</span>`
        )
        .join('');
    });
    document.querySelectorAll('.textContainer .bold-text').forEach((el) => {
      const chars = el.textContent.split('');
      el.innerHTML = chars
        .map((char) =>
          char === ' ' ? ' ' : `<span class="char">${char}</span>`
        )
        .join('');
    });
    document.querySelectorAll('.textContainer .regular-text').forEach((el) => {
      const chars = el.textContent.split('');
      el.innerHTML = chars
        .map((char) =>
          char === ' ' ? ' ' : `<span class="char">${char}</span>`
        )
        .join('');
    });

    // gsap.utils.toArray('.textContainer').forEach((container) => {
    //   if (container.classList.contains('no-parallax')) return;

    //   const chars = container.querySelectorAll('.char');

    //   gsap.fromTo(
    //     chars,
    //     {
    //       opacity: 0,
    //       scale: 0.8,
    //       x: -200, // Significant horizontal movement to make it visible
    //       y: 50, // Vertical bounce
    //       filter: 'blur(4px)',
    //       position: 'relative', // Ensure characters are relative for movement
    //     },
    //     {
    //       scrollTrigger: {
    //         trigger: container,
    //         scroller: '.timelineContainer',
    //         start: 'top 80%',
    //         toggleActions: 'play none none reverse',
    //       },
    //       opacity: 1,
    //       scale: 1,
    //       x: 0, // Return to original horizontal position
    //       y: 0, // Return to original vertical position
    //       filter: 'blur(0px)',
    //       stagger: 0.01, // Slower stagger
    //       duration: 0.08, // Faster duration
    //       ease: 'elastic.out(1, 0.75)', // Elastic bounce easing
    //     }
    //   );
    // });

    // gsap.utils.toArray('.textContainer').forEach((container) => {
    //   // if (container.classList.contains('no-parallax')) return;

    //   const chars = Array.from(container.querySelectorAll('.char'));
    //   const containerTop = container.getBoundingClientRect().top;

    //   const lines = {};
    //   const lineHeight = parseFloat(getComputedStyle(chars[0]).lineHeight);

    //   // Group chars by their Y position (line)
    //   chars.forEach((char) => {
    //     const top = Math.round(char.getBoundingClientRect().top - containerTop);
    //     const lineIndex = Math.round(top / lineHeight);
    //     if (!lines[lineIndex]) lines[lineIndex] = [];
    //     lines[lineIndex].push(char);
    //   });

    //   const timeline = gsap.timeline({
    //     scrollTrigger: {
    //       trigger: container,
    //       scroller: '.timelineContainer',
    //       start: 'top 80%',
    //       toggleActions: 'play none none reverse',
    //     },
    //   });

    //   // Animate each char with delay based on its line and position in line
    //   let allChars = [];
    //   Object.keys(lines).forEach((lineIndex, i) => {
    //     const lineChars = lines[lineIndex];
    //     lineChars.forEach((char, j) => {
    //       const delay = i * 0.08 + j * 0.01;
    //       allChars.push({ char, delay });
    //     });
    //   });

    //   allChars.forEach(({ char, delay }) => {
    //     timeline
    //       .to(
    //         char,
    //         {
    //           duration: 0.2,
    //           fontWeight: 900,
    //           color: '#146EF5',
    //           scale: 0.7,
    //           y: 6,
    //           opacity: 0, // Start opacity at 0
    //           ease: 'power2.in',
    //           rotation: 360, // Rotation starts at 360 degrees
    //         },
    //         delay
    //       )
    //       .to(
    //         char,
    //         {
    //           duration: 0.4,
    //           fontWeight: 200,
    //           color: '#fff',
    //           scale: 1,
    //           y: 0,
    //           rotation: 720, // Rotation goes to 720 degrees
    //           opacity: 1, // Animate opacity from 0 to 1
    //           ease: 'power3.inOut',
    //         },
    //         delay + 0.1 - 0.05 // Slight overlap for smoother effect
    //       )
    //       .to(
    //         char,
    //         {
    //           duration: 0, // Instant reset
    //           rotation: 0, // Ensure rotation ends at 0 degrees
    //           scale: 1, // Ensure scale ends at 1
    //           opacity: 1, // Ensure opacity stays at 1
    //         },
    //         delay + 0.8 // This ensures the rotation ends at 0 without interfering with other properties
    //       );
    //   });
    // });
    gsap.utils.toArray('.textContainer').forEach((container) => {
      if (container.classList.contains('no-parallax')) return;

      const chars = container.querySelectorAll('.char');

      gsap.fromTo(
        chars,
        {
          opacity: 0,
          scale: 0.8,
          x: -200, // Significant horizontal movement to make it visible
          y: 50, // Vertical bounce
          filter: 'blur(4px)',
          position: 'relative', // Ensure characters are relative for movement
        },
        {
          scrollTrigger: {
            trigger: container,
            scroller: '.timelineContainer',
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
          opacity: 1,
          scale: 1,
          x: 0, // Return to original horizontal position
          y: 0, // Return to original vertical position
          filter: 'blur(0px)',
          stagger: 0.01, // Slower stagger
          duration: 0.08, // Faster duration
          ease: 'elastic.out(1, 0.75)', // Elastic bounce easing
        }
      );
    });
    gsap.from('.no-parallax', {
      scrollTrigger: {
        trigger: '.article19',
        scroller: '.timelineContainer',
        start: 'top 80%',
        toggleActions: 'play none none reverse',
      },
      opacity: 0,
      x: -200,
      duration: 0.8,
      ease: 'power4.out',
    });
    gsap.utils.toArray('.imageSecond').forEach((img) => {
      const parent = img.closest('.article'); // Parent element of the image

      gsap.from(img, {
        scrollTrigger: {
          trigger: parent, // Trigger the animation based on the parent element
          scroller: '.timelineContainer', // Custom scroll container
          start: 'top 50%', // Trigger when parent reaches the halfway point of the viewport
          toggleActions: 'play none none reverse', // Animation play/reverse actions
          markers: false, // Set to true for debugging (you can remove this if needed)
        },
        opacity: 0, // Initial opacity is 0 (invisible)
        scale: 0.5, // Initial scale of the image (scaled down)
        ease: 'bounce.out', // Bounce easing for the scale animation
        duration: 1, // Animation duration
      });
    });
  }, 1000);
});

function preloadVideo(video_url, video_key, video_index, loaderContext) {
  return new Promise((resolve, reject) => {
    const video_history = videoArr.filter((obj) => obj.key === video_key);
    if (video_history.length > 0) {
      console.log('Video already exists in array ', video_history);
      resolve(video_key);
      return;
    }

    videoArr.push({
      key: video_key,
      data: null,
      loaded: 0,
    });

    fetch(video_url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to load video: ${res.status}`);
        }
        return res.blob();
      })
      .then((blob) => {
        const video_obj = videoArr.find((obj) => obj.key === video_key);
        video_obj.data = URL.createObjectURL(blob);
        video_obj.loaded = 100;
        resolve(video_key);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
}
